
import { UserPlus, Settings, PlusCircle, Trash, LogOut, ChevronDown, Shield, Compass, Radio, CalendarDays, Webhook, LayoutTemplate, BarChart2, ShieldAlert, Smile } from "lucide-react";
import { useModalStore } from "../../stores/modalStore";
import { useServerStore } from "../../stores/serverStore";
import { useMemberStore } from "../../stores/memberStore";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

export function ServerHeader({ server, role }) {
  const onOpen = useModalStore((state) => state.onOpen);
  const currentServer = useServerStore((state) => state.getCurrentServer());
  const getCurrentUser = useMemberStore((state) => state.getCurrentUser);
  
  const displayServer = currentServer || server;
  const currentUser = getCurrentUser();
  const isAdmin = (role || currentUser?.role) === "ADMIN";
  const isModerator = isAdmin || (role || currentUser?.role) === "MODERATOR";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="focus:outline-none" asChild>
        <button className="w-full text-md font-semibold px-3 flex items-center h-12 border-neutral-200 dark:border-neutral-800 border-b-2 hover:bg-zinc-700/10 dark:hover:bg-zinc-700/50 transition">
          {displayServer?.name}
          <ChevronDown className="h-5 w-5 ml-auto" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 text-xs font-medium text-black dark:text-neutral-400 space-y-[2px]">
        {isModerator && (
          <DropdownMenuItem
            onClick={() => onOpen("invite", { server: displayServer })}
            className="text-indigo-600 dark:text-indigo-400 px-3 py-2 text-sm cursor-pointer"
          >
            Invite People
            <UserPlus className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => onOpen("editServer", { server: displayServer })}
            className="px-3 py-2 text-sm cursor-pointer"
          >
            Server Settings
            <Settings className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => onOpen("members", { server: displayServer })}
            className="px-3 py-2 text-sm cursor-pointer"
          >
            Manage Members
            <Settings className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => onOpen("roleEditor", { serverId: displayServer?.id })}
            className="px-3 py-2 text-sm cursor-pointer"
          >
            Manage Roles
            <Shield className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => onOpen("webhooks", { serverId: displayServer?.id })}
            className="px-3 py-2 text-sm cursor-pointer"
          >
            Webhooks
            <Webhook className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => onOpen("automod", { serverId: displayServer?.id })}
            className="px-3 py-2 text-sm cursor-pointer"
          >
            AutoMod Rules
            <ShieldAlert className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => onOpen("emojiManager", { serverId: displayServer?.id })}
            className="px-3 py-2 text-sm cursor-pointer"
          >
            Manage Emoji
            <Smile className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => onOpen("serverInsights", { serverId: displayServer?.id })}
            className="px-3 py-2 text-sm cursor-pointer"
          >
            Server Insights
            <BarChart2 className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        {isModerator && (
          <DropdownMenuItem
            onClick={() => onOpen("createChannel", { server: displayServer })}
            className="px-3 py-2 text-sm cursor-pointer"
          >
            Create Channel
            <PlusCircle className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onClick={() => onOpen("serverEvents")}
          className="px-3 py-2 text-sm cursor-pointer"
        >
          Server Events
          <CalendarDays className="h-4 w-4 ml-auto" />
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onOpen("stage")}
          className="text-indigo-400 px-3 py-2 text-sm cursor-pointer"
        >
          Start Stage
          <Radio className="h-4 w-4 ml-auto" />
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onOpen("serverDiscovery")}
          className="px-3 py-2 text-sm cursor-pointer"
        >
          Discover Servers
          <Compass className="h-4 w-4 ml-auto" />
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onOpen("serverTemplates")}
          className="px-3 py-2 text-sm cursor-pointer"
        >
          Server Templates
          <LayoutTemplate className="h-4 w-4 ml-auto" />
        </DropdownMenuItem>
        {isModerator && <DropdownMenuSeparator />}
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => onOpen("deleteServer", { server: displayServer })}
            className="text-rose-500 px-3 py-2 text-sm cursor-pointer"
          >
            Delete Server
            <Trash className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
        {!isAdmin && (
          <DropdownMenuItem
            onClick={() => onOpen("leaveServer", { server: displayServer })}
            className="text-rose-500 px-3 py-2 text-sm cursor-pointer"
          >
            Leave Server
            <LogOut className="h-4 w-4 ml-auto" />
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
